<search-table [defaultSearchTerm]="defaultSearchTerm" 
              (onRowSelect)="handleRowSelect($event)"
              [config]="searchTableConfig"
              [allowTypes]="['campaign']">
</search-table>
